import React from "react";
import styled from "styled-components";

const ProjectsSection = styled.section`
  padding: 4rem 2rem;
  text-align: center;
  background: #f8f9fa;
`;

const SectionTitle = styled.h2`
  font-size: 2rem;
  color: #333;
  margin-bottom: 1rem;
`;

const SectionSubtitle = styled.p`
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 2rem;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  justify-content: center;
  max-width: 1200px;
  margin: auto;
`;

const ProjectCard = styled.div`
  background: #fff;
  border-radius: 10px;
  padding: 1.5rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  cursor: pointer;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }
`;

const ProjectImage = styled.img`
  width: 100%;
  border-radius: 8px;
  height: 180px;
  object-fit: cover;
  margin-bottom: 1rem;
`;

const ProjectTitle = styled.h3`
  font-size: 1.5rem;
  color: #007bff;
  margin-bottom: 0.5rem;
`;

const ProjectDescription = styled.p`
  font-size: 1rem;
  color: #555;
  margin-bottom: 1rem;
`;

const TechStack = styled.p`
  font-size: 0.9rem;
  color: #777;
  font-style: italic;
  margin-bottom: 1rem;
`;

const LinkContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;

const ProjectLink = styled.a`
  text-decoration: none;
  font-size: 1rem;
  color: #007bff;
  font-weight: bold;

  &:hover {
    text-decoration: underline;
  }
`;

const projects = [
  {
    title: "Zangupay Website",
    description:
      "A fintech platform designed to simplify financial operations for businesses and organizations.",
    techStack: "React.js, TypeScript, TailwindCSS, MongoDB, Shadcn/UI",
    imageUrl: "/assets/Zangupay.png",
    liveDemo: "https://zangupay.com",
  },
  {
    title: "SRMHub Website",
    description: "A business management platform for seamless operations.",
    techStack: "Next.js, TypeScript, Node.js, MongoDB, TailwindCSS",
    imageUrl: "/assets/srm.png",
    liveDemo: "https://srmhub.com",
  },
  {
    title: "TheeOvalStore",
    description: "An online marketplace for unique beauty and fashion items.",
    techStack: "WordPress, WooCommerce",
    imageUrl: "/assets/Theeoval.png",
    liveDemo: "https://theeovalstore.godaddysites.com",
  },
  {
    title: "Green-valley-website",
    description:
      "A modern, eco-friendly platform highlighting our commitment to sustainable agriculture. Visitors can explore seasonal crops, learn about our green farming practices, and contact us for farm-fresh produce.",
    techStack: "HTML,CSS, Javascript,Laravel",
    imageUrl: "/assets/greenvalley.png",
    github: "https://irenemuthoki.github.io/Green-Valley-frontend/",
    liveDemo: "https://irenemuthoki.github.io/Green-Valley-frontend/",
  },
  {
    title: "Health Clinic Website",
    description:
      "A modern website for a health clinic, providing appointment booking and service details.",
    techStack: "HTML, CSS, JavaScript",
    imageUrl: "/assets/health.png",
    github: "https://github.com/Irenemuthoki/HealthClinic-Website",
    liveDemo: "https://health-clinic-website.vercel.app/",
  },
  {
    title: "Real Estate Website",
    description:
      "This platform simplifies buying, selling, or renting properties with an intuitive interface.",
    techStack: "WordPress",
    imageUrl: "/assets/estate.png",
    liveDemo: "https://dollargroup-architectureanddes.godaddysites.com/",
  },
];

const Projects = () => {
  return (
    <ProjectsSection id="projects">
      <SectionTitle>Projects</SectionTitle>
      <SectionSubtitle>Some of the projects I've worked on.</SectionSubtitle>
      <GridContainer>
        {projects.map((project, index) => (
          <ProjectCard key={index}>
            <ProjectImage src={project.imageUrl} alt={project.title} />
            <ProjectTitle>{project.title}</ProjectTitle>
            <ProjectDescription>{project.description}</ProjectDescription>
            <TechStack>Tech Used: {project.techStack}</TechStack>
            <LinkContainer>
              {project.github && (
                <ProjectLink href={project.github} target="_blank">
                  GitHub
                </ProjectLink>
              )}
              {project.liveDemo && (
                <ProjectLink href={project.liveDemo} target="_blank">
                  Live Demo
                </ProjectLink>
              )}
            </LinkContainer>
          </ProjectCard>
        ))}
      </GridContainer>
    </ProjectsSection>
  );
};

export default Projects;
